/**
 * Angular polyfills entrypoint.
 * Zone.js is required by Angular for change detection.
 */
import 'zone.js';
